export default __webpack_public_path__ + "static/media/rabbit20.8480ab80.gif";